module.exports = require("./nl-BQ.d.ts");